import * as style from './style.module.scss'
import * as React from 'react'
import { Popover as ReakitPopover, PopoverArrow } from 'reakit/Popover'

const Popover = ({ children, variant, ...popover }) => {
  const popoverClass =
    variant === "dark" ? style.popoverDark : style.popover;

  return (
    <ReakitPopover className={popoverClass} {...popover}>
      {variant === "dark" ? null : <PopoverArrow {...popover} />}
      {children}
    </ReakitPopover>
  );
};

export default Popover
